module.exports = __webpack_public_path__ + "img/D201708_1.5ee1f824.jpg";